import { ContainerModule, interfaces } from 'inversify';
import { AttachmentsStore, IAttachmentsStore } from './attachments.store';
import { AttachmentsPreviewService, IAttachmentsPreviewService } from './attachmentsPreview.service';
import { AttachmentsPreviewStore, IAttachmentsPreviewStore } from './attachmentsPreview.store';
import { AttachmentUploadService, IAttachmentUploadService } from './attachmentUploadService';
import { AttachmentUploadStore, IAttachmentUploadStore } from './attachmentUploadStore';

export const attachmentsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IAttachmentUploadStore.$).to(AttachmentUploadStore).inSingletonScope();
  bind(IAttachmentUploadService.$).to(AttachmentUploadService).inSingletonScope();
  bind(IAttachmentsStore.$).to(AttachmentsStore).inSingletonScope();
  bind(IAttachmentsPreviewStore.$).to(AttachmentsPreviewStore).inSingletonScope();
  bind(IAttachmentsPreviewService.$).to(AttachmentsPreviewService).inSingletonScope();
});
